var shared = require('../internals/shared');

module.exports = shared('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/internals/function-to-string.js
// module id = 32
// module chunks = 0